module.exports = __webpack_public_path__ + "img/Rectangle 37.1320b0ca.jpg";